var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseGraphQL } from '../types/index.js';
import { getCAHolderManagerInfo, getLoginGuardianAccount } from './utils.js';
export class DIDGraphQL extends BaseGraphQL {
    constructor({ client, config }) {
        super(client);
        this._config = config;
    }
    getHolderInfoByManager(params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const client = ((_a = this._config) === null || _a === void 0 ? void 0 : _a.graphQLClient) || this._client;
            const caResult = yield getCAHolderManagerInfo(client, {
                dto: Object.assign({ skipCount: 0, maxResultCount: 1 }, params),
            });
            if (caResult.error)
                throw caResult.error;
            const result = {
                caHolderManagerInfo: caResult.data.caHolderManagerInfo
                    ? caResult.data.caHolderManagerInfo.map(item => (Object.assign(Object.assign({}, item), { loginGuardianInfo: [] })))
                    : [],
            };
            if (result.caHolderManagerInfo.length > 0) {
                const caHash = result.caHolderManagerInfo[0].caHash;
                const guardianResult = yield getLoginGuardianAccount(client, {
                    dto: {
                        chainId: params.chainId,
                        caHash,
                        skipCount: 0,
                        maxResultCount: 100,
                    },
                });
                if (guardianResult.error)
                    throw guardianResult.error;
                if (guardianResult.data.loginGuardianInfo) {
                    result.caHolderManagerInfo[0].loginGuardianInfo = guardianResult.data.loginGuardianInfo;
                }
                else {
                    result.caHolderManagerInfo[0].loginGuardianInfo = [];
                }
            }
            return result;
        });
    }
}
